export const RequestStatusesEnum = {
    DEFAULT: null,
    WAITING: 'waiting_for_response',
    FAILED: 'request_failed',
    SUCCEDED: 'request_succeded',
};
